import * as React from 'react';
export const TPAComponentsContext = React.createContext({
    mobile: false,
    rtl: false,
    seo: false,
});
export const TPAComponentsProvider = TPAComponentsContext.Provider;
export const TPAComponentsConsumer = TPAComponentsContext.Consumer;
export const useTPAComponentsContext = () => React.useContext(TPAComponentsContext);
//# sourceMappingURL=TPAComponentsConfig.js.map